import { render, staticRenderFns } from "./SocialShare.vue?vue&type=template&id=d7fc73fe"
import script from "./SocialShare.vue?vue&type=script&lang=js"
export * from "./SocialShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports